import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { Icons } from '@/app/assets/Icons';
import { ROUTERS } from '@/constants';
import { colors } from '@/theme';
import { map } from '@/utils';

import { ITypo } from '../../common';

import { Call, Global, Sms } from 'iconsax-react';

const socialLinks = [
	{
		href: ROUTERS.FB_FAN_PAGE,
		Icon: Icons.common.facebook,
		label: 'facebook',
	},
	{
		href: ROUTERS.FB_GROUP,
		Icon: Icons.common.communityGroup,
		label: 'community',
	},
	{ href: ROUTERS.TIKTOK, Icon: Icons.common.tiktok, label: 'tiktok' },
];

const ContactInformation = () => {
	return (
		<div className="col gap-6">
			<ITypo as="h3" size={20} weight="semi">
				THÔNG TIN LIÊN HỆ
			</ITypo>

			<div className="col flex gap-3">
				<Link className="flex gap-2" href={ROUTERS.PHONE_NUMBER}>
					<Call size="24" color={colors.black[1]} />
					<ITypo size={16}> 097 2222 320</ITypo>
				</Link>
				<Link className="flex gap-2" href={ROUTERS.EMAIL}>
					<Sms size="24" color={colors.black[1]} />
					<ITypo size={16}>DLA.studentsuccess@gmail.com</ITypo>
				</Link>
				<Link className="flex gap-2" href={ROUTERS.WEBSITE}>
					<Global size="24" color={colors.black[1]} />
					<ITypo size={16}> www.ptedanang.com</ITypo>
				</Link>
				<div className="row gap-6">
					{map(socialLinks, (item, idx) => (
						<Link
							href={item.href}
							key={idx}
							className="center relative size-[50px] overflow-hidden rounded-full"
							target="_blank"
							rel="noreferrer"
						>
							<Image src={item.Icon} alt="DLA Da Nang" fill />
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};

export default memo(ContactInformation);
